"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onUpdateServiceRequest = exports.onUpdateSensorAlertBySensor = exports.onCreateSensorAlertBySensor = exports.onCreateSensorAlertByHub = exports.onCreateSensorAlert = exports.onCreateSensorEventBySensor = exports.onCreateSensorEventByHub = exports.onCreateSensorEvent = exports.onDeleteSensor = exports.onUpdateSensor = exports.onCreateSensor = exports.onDeleteHub = exports.onUpdateHub = exports.onCreateHub = void 0;
exports.onCreateHub = `
  subscription OnHubCreated {
    onHubCreated {
      id
      serialNumber
      macAddress
      name
      status
    }
  }
`;
exports.onUpdateHub = `
  subscription OnHubUpdated {
    onHubUpdated {
      id
      serialNumber
      macAddress
      name
      status
    }
  }
`;
exports.onDeleteHub = `
  subscription OnHubDeleted {
    onHubDeleted {
      id
      serialNumber
      macAddress
      name
      status
    }
  }
`;
exports.onCreateSensor = `
  subscription OnSensorCreated {
    onSensorCreated {
      id
      hubId
      serialNumber
      type
      name
      location
      sublocation
      status
      lastReported
    }
  }
`;
exports.onUpdateSensor = `
  subscription OnSensorUpdated {
    onSensorUpdated {
      id
      hubId
      serialNumber
      type
      name
      location
      sublocation
      status
      lastReported
    }
  }
`;
exports.onDeleteSensor = `
  subscription OnSensorDeleted {
    onSensorDeleted {
      id
      hubId
      serialNumber
      type
      name
      location
      sublocation
      status
      lastReported
    }
  }
`;
exports.onCreateSensorEvent = `
  subscription OnSensorEventCreated {
    onSensorEventCreated {
      id
      timestamp
      sensorId
      hubId
      eventType
      value
      values
      metadata
    }
  }
`;
exports.onCreateSensorEventByHub = `
  subscription OnHubSensorEventCreated($hubId: ID!) {
    onHubSensorEventCreated(hubId: $hubId) {
      id
      timestamp
      sensorId
      hubId
      eventType
      value
      values
      metadata
    }
  }
`;
exports.onCreateSensorEventBySensor = `
  subscription OnSensorSensorEventCreated($sensorId: ID!) {
    onSensorSensorEventCreated(sensorId: $sensorId) {
      id
      timestamp
      sensorId
      hubId
      eventType
      value
      values
      metadata
    }
  }
`;
exports.onCreateSensorAlert = `
  subscription OnSensorAlertCreated {
    onSensorAlertCreated {
      id
      timestamp
      sensorId
      hubId
      alertType
      severity
      message
      value
      metadata
      status
      acknowledgedAt
      acknowledgedBy
    }
  }
`;
exports.onCreateSensorAlertByHub = `
  subscription OnHubSensorAlertCreated($hubId: ID!) {
    onHubSensorAlertCreated(hubId: $hubId) {
      id
      timestamp
      sensorId
      hubId
      alertType
      severity
      message
      value
      metadata
      status
      acknowledgedAt
      acknowledgedBy
    }
  }
`;
exports.onCreateSensorAlertBySensor = `
  subscription OnSensorSensorAlertCreated($sensorId: ID!) {
    onSensorSensorAlertCreated(sensorId: $sensorId) {
      id
      timestamp
      sensorId
      hubId
      alertType
      severity
      message
      value
      metadata
      status
      acknowledgedAt
      acknowledgedBy
    }
  }
`;
exports.onUpdateSensorAlertBySensor = `
  subscription OnSensorSensorAlertUpdated($sensorId: ID!) {
    onSensorSensorAlertUpdated(sensorId: $sensorId) {
      id
      timestamp
      sensorId
      hubId
      alertType
      severity
      message
      value
      metadata
      status
      acknowledgedAt
      acknowledgedBy
      serviceRequest {
        id
        status
        scheduledDate
      }
    }
  }
`;
exports.onUpdateServiceRequest = `
  subscription OnServiceRequestUpdated {
    onServiceRequestUpdated {
      id
      status
      scheduledDate
      alertId
    }
  }
`;
